import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function TripGeofencingDetails({
    label,
    options,
    isGeofencing,
    onChange,
    isEditable,
}) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={isGeofencing}
                options={options}
                onSave={onChange}
                isEditable={isEditable}
            />
        </EuiFlexItem>
    );
}
